import { testimonialList } from '@/mocks/animeData';

export default function TestimonialsSection() {
  return (
    <section id="feedback" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
            <i className="ri-chat-heart-line"></i>
            追番同好口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">看过的人这样说</h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            来自高甜党、纯爱党、狗粮党和暧昧党的真实反馈，看看大家在这里都找到了什么心动瞬间。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonialList.map((t) => (
            <figure key={t.id} className="flex flex-col rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-1 text-amber-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">“{t.quote}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${t.avatar} text-lg`}></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                  <span className="text-xs text-secondary-700">{t.tag}</span>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}